import React from 'react'

import { DialogContent as MuiDialogContent, DialogContentProps } from '@material-ui/core'

const DialogContent: React.FC<DialogContentProps> = ({ children, ...rest }) => (
  <MuiDialogContent {...rest}>{children}</MuiDialogContent>
)

export default DialogContent
